import styled from '@emotion/styled';
import Badge from 'patient-ping-remedy/packages/badge';

export const AttemptsCell = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
`;

/* Badge is a padded pill by default; square it off so a one- or two-digit attempt reads as a tile. */
export const AttemptBadge = styled(Badge)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  height: 2.4rem;
  padding: 0 0.4rem;
  border-radius: 0.3rem;
`;
